import React from 'react';
import { panelClass } from '../../governed-mcp-gateway/components/GatewayUi';
import { AUTH_OPTIONS } from '../llmGatewayConstants';
import type { AuthMethod, GatewayFormState } from '../llmGatewayTypes';
import GovernancePoliciesEditor from '../components/GovernancePoliciesEditor';

export default function GovernanceStep({
  form,
  errors,
  isLight,
  onChange,
}: {
  form: GatewayFormState;
  errors: Record<string, string>;
  isLight: boolean;
  onChange: (next: GatewayFormState) => void;
}) {
  return (
    <div className="space-y-4">
      <section className={`${panelClass(isLight)} p-5`}>
        <h3 className={`text-sm font-semibold ${isLight ? 'text-neutral-900' : 'text-white'}`}>Authentication</h3>
        <p className={`mt-1 text-xs ${isLight ? 'text-neutral-500' : 'text-neutral-400'}`}>
          How calling applications identify themselves to this gateway.
        </p>
        <div className="mt-4 grid sm:grid-cols-3 gap-3">
          {AUTH_OPTIONS.map((option) => {
            const checked = form.authMethod === option.value;
            return (
              <label
                key={option.value}
                className={`rounded-xl border p-3 cursor-pointer ${
                  checked
                    ? isLight
                      ? 'border-indigo-300 bg-indigo-50/70'
                      : 'border-indigo-500/40 bg-indigo-500/10'
                    : isLight
                      ? 'border-neutral-200'
                      : 'border-neutral-800'
                }`}
              >
                <span className="flex items-center gap-2">
                  <input
                    type="radio"
                    name="auth-method"
                    checked={checked}
                    onChange={() => onChange({ ...form, authMethod: option.value as AuthMethod })}
                  />
                  <span className={`text-sm font-medium ${isLight ? 'text-neutral-800' : 'text-neutral-100'}`}>{option.label}</span>
                </span>
                <span className={`block mt-1.5 text-xs ${isLight ? 'text-neutral-500' : 'text-neutral-400'}`}>{option.hint}</span>
              </label>
            );
          })}
        </div>
        {errors.authMethod ? <p className="mt-2 text-xs text-red-500">{errors.authMethod}</p> : null}
      </section>

      <section className={`${panelClass(isLight)} p-5`}>
        <GovernancePoliciesEditor
          governance={form.governance}
          errors={errors}
          isLight={isLight}
          onChange={(governance) => onChange({ ...form, governance })}
        />
      </section>
    </div>
  );
}
